import { useNavigate } from 'react-router-dom'
import { ReactComponent as YourLogo } from '../assets/yorbit-branco.svg'
import './NotFoundPage.css'

const NotFoundPage = () => {
  const navigate = useNavigate()

  return (
    <div className='not-found-container'>
      <div className='message-container'>
        <h1>Ops! Página não encontrada</h1>
        <div className='not-found-person'>
          <h1>4</h1>
          <YourLogo className='logo-svg' />
          <h1>4</h1>
        </div>

        <button onClick={() => navigate('/')} className='home-button'>
          Voltar ao início
        </button>
      </div>
    </div>
  )
}

export default NotFoundPage
